"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _components = require("../../components");
var _utils = require("../../utils");
require("./SelectPharmacy.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SelectPharmacy = function SelectPharmacy(_ref) {
  var pharmacies = _ref.pharmacies,
    onModalOpen = _ref.onModalOpen,
    loadingPatientPharmacies = _ref.loadingPatientPharmacies,
    defaultPharmacy = _ref.defaultPharmacy,
    currentPharmacies = _ref.currentPharmacies,
    refetchPatientsPharmacies = _ref.refetchPatientsPharmacies,
    _ref$patientId = _ref.patientId,
    patientId = _ref$patientId === void 0 ? 'me' : _ref$patientId;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loadingUpdate = _useState2[0],
    setLoadingUpdate = _useState2[1];
  var isAmazon = function isAmazon(pharmacy) {
    return pharmacy.pharmacyId.toString() === process.env.REACT_APP_DOSESPOT_ID_FOR_AMAZON;
  };
  var selectPharmacy = function selectPharmacy() {
    var existingPharmacies = currentPharmacies && currentPharmacies.map(function (p) {
      return p.pharmacyId;
    });
    setLoadingUpdate(true);
    _utils.api.post((0, _utils.getPatientPharmacyUrl)(parseInt(process.env.REACT_APP_DOSESPOT_ID_FOR_AMAZON, 10), patientId), {
      existingPharmacies: existingPharmacies
    }).then(function () {
      setLoadingUpdate(false);
      _utils.toast.success({
        title: 'Success',
        description: 'Your preferred pharmacy has been saved.'
      });
      refetchPatientsPharmacies();
    });
  };
  if (loadingPatientPharmacies || loadingUpdate) {
    return /*#__PURE__*/_react.default.createElement(_spin.default, {
      size: 'small'
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "select-pharmacy mt-[24px]"
  }, (0, _lodash.isEmpty)(pharmacies) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-description-regular"
  }, "Where would you like your future prescriptions to be sent?"), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "w-[282px] mt-[24px]",
    size: "large",
    onClick: onModalOpen
  }, "Add Pharmacy"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-description-regular mt-[32px]"
  }, "If you prefer, you can have your prescriptions sent to", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://pharmacy.amazon.com"
  }, "Amazon Pharmacy"), "."), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "w-[282px] mt-[24px]",
    size: "large",
    onClick: selectPharmacy
  }, "Use Amazon Pharmacy"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "current-pharmacy"
  }, isAmazon(defaultPharmacy) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "preferred-pharmacy tw-description-light"
  }, "Your prescriptions are being filled by", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://pharmacy.amazon.com",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Amazon Pharmacy"), ". Following Payment, Amazon will typically take 5 days to deliver your prescription."), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "preferred-pharmacy tw-description-regular mt-[32px]"
  }, "Want to use your local pharmacy in the future? No problem!"), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "mt-[24px]",
    type: "default",
    size: "large",
    onClick: onModalOpen
  }, "Change pharmacy"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-flow-row gap-y-[24px] lg:grid-flow-col lg:grid-cols-2 lg:gap-x-[20px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card p-[24px] pb-[40px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium"
  }, "My pharmacy"), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-15 mt-[12px] mb-[20px]"
  }), /*#__PURE__*/_react.default.createElement("address", {
    className: "tw-label-light mt-[16px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-regular"
  }, defaultPharmacy.storeName), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[8px]"
  }, defaultPharmacy.address1), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[8px]"
  }, defaultPharmacy.city, ", ", defaultPharmacy.state, " ", defaultPharmacy.zipCode), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    className: "mt-[24px]",
    size: "large",
    url: "tel:".concat(defaultPharmacy.primaryPhone)
  }, (0, _utils.formatPhoneNumber)(defaultPharmacy.primaryPhone)))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "mt-[32px] max-w-[282px]",
    type: "default",
    size: "large",
    onClick: onModalOpen
  }, "Change pharmacy"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card p-[24px] pb-[40px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-sm-medium"
  }, "Amazon Pharmacy"), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-15 mt-[12px] mb-[20px]"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-light"
  }, "If you prefer, you can have your prescriptions sent to", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://pharmacy.amazon.com",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Amazon Pharmacy"), "."), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    className: "mt-[40px] max-w-[282px]",
    type: "default",
    size: "large",
    onClick: selectPharmacy
  }, "Use Amazon Pharmacy"))))));
};
SelectPharmacy.propTypes = {
  className: _propTypes.default.string,
  pharmacy: _propTypes.default.shape({
    StoreName: _propTypes.default.string,
    Address1: _propTypes.default.string
  }),
  onModalOpen: _propTypes.default.func,
  loadingPatientPharmacies: _propTypes.default.bool
};
var _default = SelectPharmacy;
exports.default = _default;